import { render, staticRenderFns } from "./IsiTeksSub.vue?vue&type=template&id=46a608f4&"
import script from "./IsiTeksSub.vue?vue&type=script&lang=js&"
export * from "./IsiTeksSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports